import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

export default function FeaturedSection() {
  const hotMovies = movies.filter((m) => m.isHot).slice(0, 6);
  const newMovies = movies.filter((m) => m.isNew && !m.isHot).slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <div className="flex items-center justify-between mb-5">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">全网最受欢迎的高清影视内容</p>
            </div>
            <Link
              to="/category/movie"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看更多
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
            {hotMovies.map((movie) => (
              <MovieCard key={movie.id} {...movie} />
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-5">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                最新上线
              </h2>
              <p className="text-sm text-foreground-500 mt-1">刚刚更新的热门影视</p>
            </div>
            <Link
              to="/category/movie"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看更多
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
            {newMovies.map((movie) => (
              <MovieCard key={movie.id} {...movie} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}